import React from 'react'
import { Portal } from 'react-portal'
import Button from '../button'

import S from './styled'

const Modal = ({ children, isOpened, actions = [], noScroll, padding, flexRow, fullWidth, gray }) => isOpened ? (
  <Portal>
    <S.ModalOverlay>
      <S.Modal fullWidth={fullWidth} gray={gray}>
        <S.ModalContent noScroll={noScroll} padding={padding} flexRow={flexRow}>
          {children}
        </S.ModalContent>
        <S.ModalFooter>
          {
            actions.map(action => <Button {...{
              key: action.title,
              blue: action.blue,
              outlined: action.outlined,
              green: action.green,
              red: action.red,
              onClick: action.action,
              disabled: action.disabled,
            }}>{action.title}</Button>)
          }
        </S.ModalFooter>
      </S.Modal>
    </S.ModalOverlay>
  </Portal>
) : null

export const ConfirmModal = ({ children, isOpened, onClose, onConfirm, redConfirm, confirmTitle, cancelTitle }) => (
  <Modal {...{ isOpened }} actions={[{
    title: cancelTitle || 'Cancel',
    action: onClose,
    blue: true,
    outlined: true,
  }, {
    title: confirmTitle || 'Confirm',
    action: onConfirm,
    blue: !redConfirm,
    red: !!redConfirm,
  }]}>
    {children}
  </Modal>
)

export default Modal
